"use client";

import React, { useEffect, useRef, useState } from "react";
import { Instagram, ArrowRight, Heart } from "lucide-react";
import { Link } from "@/components/common/Link";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.1,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const galleryItems = [{
  id: 1,
  type: "image",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626701/img/funffy_bento_1.png",
  className: "col-span-2 row-span-2"
}, {
  id: 2,
  type: "image",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626701/img/funffy_bento_2.png",
  className: "col-span-1 row-span-1"
}, {
  id: 3,
  type: "image",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626701/img/funffy_bento_3.png",
  className: "col-span-1 row-span-2"
}, {
  id: 4,
  type: "follow",
  src: "",
  className: "col-span-2 md:col-span-1 row-span-1"
}, {
  id: 5,
  type: "image",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626701/img/funffy_bento_4.png",
  className: "col-span-1 row-span-1"
}, {
  id: 6,
  type: "image",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626701/img/funffy_bento_5.png",
  className: "col-span-2 row-span-1"
}, {
  id: 7,
  type: "image",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626701/img/funffy_bento_6.png",
  className: "col-span-2 md:col-span-2 lg:col-span-1 row-span-1"
}];
export default function FunffyMoments() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  return;
}